import Receipt from 'feature/receipt/receipt';

export default Receipt;
